import React, { useState, useEffect } from 'react';
import { ModalMessage } from "../shared/modal-message.jsx";

function ToolTip({ modalOpen, setModalOpen, text }) {
  const [modalOpenTimeout, setModalOpenTimeout] = useState(null);

  const openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (modalOpenTimeout == null) {
      setModalOpenTimeout(
        setTimeout(() => { setModalOpen(e, true); }, 1000)
      );
    }
  }

  const closeModal = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (modalOpenTimeout != null) {
      clearTimeout(modalOpenTimeout);

      setModalOpenTimeout(null);
    }

    setModalOpen(e, false);
  }

  return <ModalMessage
    modalOpen={modalOpen}
    modalClose={closeModal}
    body={text}
    position={{ left: "20px", top: "30%", position: "relative", zIndex: 20 }
    }
  />
}

export { ToolTip };